<template>
  <v-dialog v-model="internal" max-width="600" overlay-opacity="0.59">
    <v-card class="pa-5 text-center" data-testid="aml-approved">
      <v-icon color="#00c853" size="40" class="mb-2">mdi-check-circle</v-icon>
      <div class="text-h6 mb-2">{{ $t('instructions.amlApprovedModalTitle') }}</div>
      <div v-if="operationAlias" class="font-weight-bold mb-1">{{ operationAlias }}</div>
      <div class="text-body-2 mb-5">{{ $t('instructions.amlApprovedModalMessage') }}</div>
      <operation-approval-progress approved class="my-7" :operation-alias="operationAlias" />
      <div class="d-flex justify-space-between  mt-3 flex-wrap button-gap">
        <v-btn outlined @click="close">{{ $t('instructions.close') }}</v-btn>
        <v-btn color="primary" @click="goToOperations">{{ $t('instructions.goToOperations') }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import OperationApprovalProgress from '@/components/operations/OperationApprovalProgress.vue'

export default {
  name: 'AmlApprovedModal',
  components: { OperationApprovalProgress },
  props: {
    value: { type: Boolean, default: false },
    operationAlias: { type: String, default: '' }
  },
  computed: {
    internal: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    goToOperations () {
      this.close()
      if (this.$route.name === 'operations') return
      this.$router.push({ name: 'operations' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.button-gap { gap: 12px; }
</style>
